module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/ffe62bca4416b73346f7c5fa2f85ab6d.png";